<template>
  <div class="student-graduation">
    <div class="student-graduation__shell">
      <section class="student-graduation__header-card">
        <div class="student-graduation__header-top">
          <!-- <img
            src="@/assets/images/NuevoLogoIbero.png"
            alt="Corporación Universitaria Iberoamericana"
            class="student-graduation__logo"
          >

          <button type="button" class="student-graduation__refresh" @click="refreshAll">
            Actualizar información
          </button> -->
        </div>

        <div class="titlePage student-graduation__title">
          Proceso de grado
        </div>

        <p class="student-graduation__intro">
          Consulta el estado general del proceso de grado, los documentos registrados, los avales institucionales y la orden de pago asociada a derechos de grado.
        </p>
        <p class="student-graduation__intro">
          Aplica sólo para proceso de grado ordinario.
        </p>
      </section>

      <transition name="student-graduation__completion-transition">
        <div
          v-if="shouldShowCompletionModal"
          class="student-graduation__completion-overlay"
          @click.self="closeCompletionModal"
        >
          <article class="student-graduation__completion-modal">
            <button
              type="button"
              class="student-graduation__completion-close"
              aria-label="Cerrar mensaje de felicitación"
              @click="closeCompletionModal"
            >
              ×
            </button>

            <div class="student-graduation__completion-shell">
              <span class="student-graduation__completion-badge">Proceso completado</span>

              <!-- <div class="student-graduation__completion-markers" aria-hidden="true">
                <span></span>
                <span></span>
                <span></span>
              </div> -->

              <h2>¡Felicitaciones! Has finalizado exitosamente tu proceso de postulación a grado.</h2>

              <div class="student-graduation__completion-copy">
                <p>Cinco (5) días antes de la ceremonia recibirás un correo electrónico con toda la información relacionada con el evento, incluyendo fecha, horario, lugar, recomendaciones y demás aspectos importantes para tu participación.</p>
                <p>Te invitamos a estar atento(a) a tu correo institucional y personal registrado en la Universidad.</p>
                <p>¡Nos sentimos orgullosos de acompañarte en este importante logro académico! 🎓✨</p>
              </div>

              <!-- <div class="student-graduation__completion-highlights">
                <span>Documentos verificados</span>
                <span>Avales completos</span>
                <span>Orden registrada como pagada</span>
              </div> -->

              <button
                type="button"
                class="student-graduation__completion-action"
                @click="closeCompletionModal"
              >
                Entendido
              </button>
            </div>
          </article>
        </div>
      </transition>

      <main v-if="summary && accessState.hasAccess" class="student-graduation__content">
        <section class="student-graduation__hero">
          <div class="student-graduation__hero-main">
            <span class="student-graduation__callout">
              {{ summary.call.name }}
            </span>

            <h2>{{ summary.student.name }}</h2>

            <p class="student-graduation__hero-meta">
              {{ summary.student.code }} · {{ summary.student.program }} · {{ summary.student.level }}
            </p>

            <div
              v-if="availableInscriptions.length > 1"
              class="student-graduation__program-switcher"
            >
              <p class="student-graduation__program-switcher-label">
                Tienes más de una inscripción de grado.
              </p>
               <p class="student-graduation__program-switcher-label">
                Selecciona el programa que quieres consultar:
              </p>

              <div class="student-graduation__program-switcher-options">
                <button
                  v-for="inscription in availableInscriptions"
                  :key="inscription._inscriptionKey"
                  type="button"
                  class="student-graduation__program-switcher-option"
                  :class="{ 'is-active': selectedInscriptionKey === inscription._inscriptionKey }"
                  @click="changeSelectedInscription(inscription._inscriptionKey)"
                >
                  <strong>{{ getValueFromRecord(inscription, ['program', 'Program']) }}</strong>
                  <span>{{ getValueFromRecord(inscription, ['codProgram', 'CodProgram']) }} · {{ getValueFromRecord(inscription, ['typeProgram', 'TypeProgram']) }}</span>
                </button>
              </div>
            </div>

            <div class="student-graduation__detail-grid">
              <article>
                <span>Facultad</span>
                <strong>{{ summary.student.faculty }}</strong>
              </article>

              <article>
                <span>Documento</span>
                <strong>{{ summary.student.documentType }} · {{ summary.student.documentNumber }}</strong>
              </article>

              <article>
                <span>Sede</span>
                <strong>{{ summary.student.campus }}</strong>
              </article>

              <article>
                <span>Inscripción</span>
                <strong>{{ summary.call.registrationDate }}</strong>
              </article>

              <article>
                <span>Ceremonia</span>
                <!-- <strong>{{ summary.call.ceremonyDate }}</strong> -->
                 <strong>Por confirmar</strong>
              </article>

              <article>
                <span>Lugar</span>
                <!-- <strong>{{ summary.call.ceremonySite }}</strong> -->
                 <strong>BOGOTÁ</strong>
              </article>

              <!-- <article>
                <span>Última actualización</span>
                <strong>{{ summary.lastUpdate }}</strong>
              </article> -->
            </div>
          </div>

          <!-- <aside class="student-graduation__hero-side">
            <span class="student-graduation__status" :class="statusClass(summary.statusTone)">
              {{ summary.status }}
            </span> -->

            <!-- <p>{{ summary.statusDescription }}</p> -->

            <!-- <div class="student-graduation__next-step">
              <span>Próximo paso</span>
              <strong>{{ summary.nextStepTitle }}</strong>
              <p>{{ summary.nextStepDescription }}</p>
            </div> -->
          <!-- </aside> -->
        </section>

        <div
          v-if="feedback.message"
          class="student-graduation__feedback"
          :class="'is-' + feedback.tone"
        >
          {{ feedback.message }}
        </div>

        <nav class="student-graduation__tabs">
          <button
            v-for="tabItem in tabs"
            :key="tabItem.id"
            type="button"
            :class="{ 'is-active': activeTab === tabItem.id }"
            @click="changeTab(tabItem.id)"
          >
            {{ tabItem.label }}
          </button>
        </nav>

        <section class="student-graduation__panel">
          <div v-if="isActiveTabLoading" class="student-graduation__loading-panel">
            Cargando información de la sección...
          </div>

          <graduation-summary-section
            v-else-if="activeTab === 'summary'"
            :summary="summary"
          />

          <graduation-documents-section
            v-else-if="activeTab === 'documents'"
            :documents="documents"
          />

          <graduation-approvals-section
            v-else-if="activeTab === 'approvals'"
            :approvals="approvals"
          />

          <graduation-billing-section
            v-else
            :billing="billing"
          />
        </section>
      </main>

      <section v-else-if="accessState.loaded && !accessState.hasAccess" class="student-graduation__empty-state">
        <h2>Proceso de grados no disponible</h2>
        <p>{{ accessState.message }}</p>
      </section>

      <div v-else class="student-graduation__initial-loading">
        Cargando información del proceso...
      </div>
    </div>
  </div>
</template>

<script>
import GraduationApprovalsSection from './sections/GraduationApprovalsSection.vue'
import GraduationBillingSection from './sections/GraduationBillingSection.vue'
import GraduationDocumentsSection from './sections/GraduationDocumentsSection.vue'
import GraduationSummarySection from './sections/GraduationSummarySection.vue'
import IberoHelpers from '@/store/helpers.js'
import {
  getGraduationApprovals,
  getGraduationBilling,
  getGraduationDocuments,
  getGraduationProcessSummary,
} from '@/services/studentGraduationProcess.service'

// const STUDENT_GRADUATION_ID_BANNER_OVERRIDE = '100231688'

export default {
  name: 'StudentGraduationProcess',
  components: {
    GraduationApprovalsSection,
    GraduationBillingSection,
    GraduationDocumentsSection,
    GraduationSummarySection,
  },
  data () {
    return {
      tabs: [
        { id: 'summary', label: 'Resumen del proceso' },
        { id: 'documents', label: 'Documentos' },
        { id: 'approvals', label: 'Avales' },
        { id: 'billing', label: 'Orden de pago' },
      ],
      activeTab: 'summary',
      summary: null,
      documents: [],
      approvals: [],
      approvalsSource: [],
      documentsSource: null,
      paymentOrdersSource: [],
      sessionStudent: null,
      availableInscriptions: [],
      selectedInscriptionKey: '',
      activeInscriptionStudent: null,
      inscriptionAccess: null,
      activeGrade: null,
      accessState: {
        loaded: false,
        hasAccess: false,
        reason: '',
        message: '',
      },
      approvalsSourceLoaded: false,
      documentsSourceLoaded: false,
      paymentOrdersSourceLoaded: false,
      billing: null,
      sectionLoaded: {
        summary: false,
        documents: false,
        approvals: false,
        billing: false,
      },
      loading: {
        summary: false,
        documents: false,
        approvals: false,
        billing: false,
      },
      feedback: {
        tone: 'info',
        message: '',
      },
      completionModalDismissed: false,
    }
  },
  computed: {
    isActiveTabLoading () {
      return this.loading[this.activeTab]
    },
    isProcessCompleted () {
      return Boolean(
        this.summary &&
        (
          this.summary.statusTone === 'success' ||
          (
            Array.isArray(this.summary.timeline) &&
            this.summary.timeline.length > 0 &&
            this.summary.timeline.every(item => item && item.status === 'completed')
          )
        )
      )
    },
    shouldShowCompletionModal () {
      return this.isProcessCompleted && !this.completionModalDismissed
    },
    selectedInscriptionPeriod () {
      return this.getValueFromRecord(this.activeInscriptionStudent, ['period_Grade', 'Period_Grade']) || 'actual'
    },
  },
  created () {
    this.initializeProcess()
  },
  methods: {
    statusClass (tone) {
      return 'is-' + tone
    },
    closeCompletionModal () {
      this.completionModalDismissed = true
    },
    getSummaryContext () {
      return {
        sessionUser: this.sessionStudent,
        availableInscriptions: this.availableInscriptions,
        inscriptionStudent: this.activeInscriptionStudent,
        inscriptionAccess: this.inscriptionAccess,
        activeGrade: this.activeGrade,
        documentsSource: this.documentsSource,
        approvals: this.approvalsSource,
        paymentOrders: this.paymentOrdersSource,
        programCatalog: this.$store.state.ProgramsList,
        programCodeCatalog: this.$store.state.ProgramCodeList,
      }
    },
    hasAllSummarySourcesLoaded () {
      return this.documentsSourceLoaded && this.approvalsSourceLoaded && this.paymentOrdersSourceLoaded
    },
    async syncSummaryState () {
      if (!this.accessState.hasAccess) {
        return
      }

      this.summary = await getGraduationProcessSummary(this.getSummaryContext())

      if (this.hasAllSummarySourcesLoaded()) {
        this.feedback = {
          tone: 'info',
          message: '',
        }
      }
    },
    async initializeProcess () {
      this.sessionStudent = this.resolveLoggedStudent()
      await this.loadSummary(true)
    },
    resolveLoggedStudent () {
      const sessionStudent = this.$session.get('IberoJWTAdminLogin')
      if (!sessionStudent || typeof sessionStudent !== 'object') {
        return null
      }

      return sessionStudent
    },
    getResponsePayload (response) {
      if (response && Object.prototype.hasOwnProperty.call(response, 'data')) {
        return response.data
      }

      return response
    },
    getResponseItem (response) {
      const payload = this.getResponsePayload(response)

      if (Array.isArray(payload)) {
        return payload[0] || null
      }

      return payload && typeof payload === 'object' ? payload : null
    },
    getResponseItems (response) {
      const payload = this.getResponsePayload(response)

      if (Array.isArray(payload)) {
        return payload.filter(item => item && typeof item === 'object')
      }

      return payload && typeof payload === 'object' ? [payload] : []
    },
    getValueFromRecord (record, keys = []) {
      if (!record || typeof record !== 'object') {
        return ''
      }

      for (const key of keys) {
        const value = record[key]
        if (value !== null && value !== undefined && String(value).trim() !== '') {
          return String(value).trim()
        }
      }

      return ''
    },
    normalizeComparableValue (value) {
      return String(value || '').trim().toUpperCase()
    },
    getNumericValue (value) {
      const parsedValue = Number(value)
      return Number.isNaN(parsedValue) ? 0 : parsedValue
    },
    buildInscriptionKey (record) {
      return [
        this.getValueFromRecord(record, ['id', 'Id']),
        this.getValueFromRecord(record, ['id_Grade', 'Id_Grade']),
        this.getValueFromRecord(record, ['codProgram', 'CodProgram']),
        this.getValueFromRecord(record, ['period_Grade', 'Period_Grade']),
      ].join('|')
    },
    getLatestInscriptions (records) {
      const sortedRecords = (Array.isArray(records) ? records : [])
        .filter(record => record && typeof record === 'object')
        .sort((leftRecord, rightRecord) => {
          return this.getNumericValue(this.getValueFromRecord(rightRecord, ['id', 'Id'])) -
            this.getNumericValue(this.getValueFromRecord(leftRecord, ['id', 'Id']))
        })

      if (sortedRecords.length === 0) {
        return []
      }

      const latestPeriod = this.normalizeComparableValue(this.getValueFromRecord(sortedRecords[0], ['period_Grade', 'Period_Grade']))
      if (!latestPeriod) {
        return [sortedRecords[0]]
      }

      return sortedRecords.filter(record => {
        return this.normalizeComparableValue(this.getValueFromRecord(record, ['period_Grade', 'Period_Grade'])) === latestPeriod
      })
    },
    buildAccessRecordFromInscription (record) {
      if (!record || typeof record !== 'object') {
        return null
      }

      const statusAccess = this.availableInscriptions.length > 1 ? 'ESTUDIANTE_INSCRITO_MULTIPROGRAMA' : 'ESTUDIANTE_INSCRITO'

      return {
        ...record,
        hasAccess: true,
        HasAccess: true,
        statusAccess: statusAccess,
        StatusAccess: statusAccess,
      }
    },
    applySelectedInscription (inscriptionKey = '') {
      if (!Array.isArray(this.availableInscriptions) || this.availableInscriptions.length === 0) {
        this.selectedInscriptionKey = ''
        this.activeInscriptionStudent = null
        this.inscriptionAccess = null
        return
      }

      const selectedInscription = this.availableInscriptions.find(record => record._inscriptionKey === inscriptionKey) || this.availableInscriptions[0]

      this.selectedInscriptionKey = selectedInscription._inscriptionKey
      this.activeInscriptionStudent = selectedInscription
      this.inscriptionAccess = this.buildAccessRecordFromInscription(selectedInscription)
    },
    resetSelectionViewState () {
      this.summary = null
      this.documents = []
      this.approvals = []
      this.billing = null
      this.documentsSource = null
      this.documentsSourceLoaded = false
      this.sectionLoaded.summary = false
      this.sectionLoaded.documents = false
      this.sectionLoaded.approvals = false
      this.sectionLoaded.billing = false
      this.completionModalDismissed = false
    },
    async changeSelectedInscription (inscriptionKey) {
      if (!inscriptionKey || inscriptionKey === this.selectedInscriptionKey) {
        return
      }

      this.applySelectedInscription(inscriptionKey)
      this.resetSelectionViewState()
      await this.loadSummary()
      if (this.activeTab !== 'summary') {
        await this.ensureTabData(this.activeTab)
      }
    },
    async ensureAccessState (force) {
      if (this.accessState.loaded && !force) {
        return this.accessState
      }

      this.sessionStudent = this.resolveLoggedStudent()
      this.availableInscriptions = []
      this.selectedInscriptionKey = ''
      this.activeInscriptionStudent = null
      this.inscriptionAccess = null
      this.activeGrade = null

      if (!this.sessionStudent || !this.sessionStudent.idBanner) {
        this.accessState = {
          loaded: true,
          hasAccess: false,
          reason: 'missing_idbanner',
          message: 'No fue posible identificar el idBanner de la persona logeada.',
        }
        return this.accessState
      }

      const gradeResponse = await IberoHelpers.getGradeActive(this.$store)
      if (gradeResponse && gradeResponse !== false) {
        this.activeGrade = this.getResponseItem(gradeResponse)
      }

      const detailResponse = await IberoHelpers.GetActiveInscriptionStudentByIdBanner(this.$store, this.sessionStudent.idBanner)
      if (!detailResponse || detailResponse === false) {
        throw new Error('No fue posible consultar las inscripciones de grado del estudiante.')
      }

      const latestInscriptions = this.getLatestInscriptions(this.getResponseItems(detailResponse))
        .map(record => ({
          ...record,
          _inscriptionKey: this.buildInscriptionKey(record),
        }))

      if (latestInscriptions.length === 0) {
        this.accessState = {
          loaded: true,
          hasAccess: false,
          reason: 'not_enrolled',
          message: 'La persona logeada no aparece inscrita en un proceso de grados disponible para consulta.',
        }
        return this.accessState
      }

      this.availableInscriptions = latestInscriptions
      this.applySelectedInscription()
      this.accessState = {
        loaded: true,
        hasAccess: true,
        reason: '',
        message: '',
      }

      return this.accessState
    },
    async ensureDocumentsSource (force) {
      if (this.documentsSourceLoaded && !force) {
        return this.documentsSource
      }

      await this.ensureAccessState(force)
      const activeIdBanner = this.getValueFromRecord(this.activeInscriptionStudent, ['idBanner', 'IdBanner']) || (this.sessionStudent && this.sessionStudent.idBanner)
      const activeIdPerson = this.getValueFromRecord(this.activeInscriptionStudent, ['id', 'Id'])
      const activeIdGrade = this.getValueFromRecord(this.activeInscriptionStudent, ['id_Grade', 'Id_Grade'])

      if (!this.accessState.hasAccess || !activeIdBanner) {
        this.documentsSource = null
        this.documentsSourceLoaded = true
        return this.documentsSource
      }

      const documentsResponse = await IberoHelpers.GetActiveInscriptionFilesByIdBanner(this.$store, activeIdBanner, {
        idPerson: activeIdPerson,
        idGrade: activeIdGrade,
      })
      if (!documentsResponse || documentsResponse === false) {
        throw new Error('No fue posible consultar los documentos del estudiante.')
      }

      this.documentsSource = this.getResponseItem(documentsResponse) || null
      this.documentsSourceLoaded = true

      return this.documentsSource
    },
    async ensureApprovalsSource (force) {
      if (this.approvalsSourceLoaded && !force) {
        return this.approvalsSource
      }

      await this.ensureAccessState(force)
      const activeIdBanner = this.getValueFromRecord(this.activeInscriptionStudent, ['idBanner', 'IdBanner']) || (this.sessionStudent && this.sessionStudent.idBanner)

      if (!this.accessState.hasAccess || !activeIdBanner) {
        this.approvalsSource = []
        this.approvalsSourceLoaded = true
        return this.approvalsSource
      }

      const approvalsResponse = await IberoHelpers.GetHoldStatusByIdBanner(this.$store, activeIdBanner)
      if (!approvalsResponse || approvalsResponse === false) {
        throw new Error('No fue posible consultar los avales del estudiante.')
      }

      this.approvalsSource = approvalsResponse && Array.isArray(approvalsResponse.data)
        ? approvalsResponse.data
        : []
      this.approvalsSourceLoaded = true

      return this.approvalsSource
    },
    async ensurePaymentOrdersSource (force) {
      if (this.paymentOrdersSourceLoaded && !force) {
        return this.paymentOrdersSource
      }

      await this.ensureAccessState(force)
      const activeIdBanner = this.getValueFromRecord(this.activeInscriptionStudent, ['idBanner', 'IdBanner']) || (this.sessionStudent && this.sessionStudent.idBanner)

      if (!this.accessState.hasAccess || !activeIdBanner) {
        this.paymentOrdersSource = []
        this.paymentOrdersSourceLoaded = true
        return this.paymentOrdersSource
      }

      const paymentOrdersResponse = await IberoHelpers.GetPaymentOrdersByClient(this.$store, activeIdBanner)
      if (!paymentOrdersResponse || paymentOrdersResponse === false) {
        throw new Error('No fue posible consultar las ordenes de pago del estudiante.')
      }

      this.paymentOrdersSource = paymentOrdersResponse && Array.isArray(paymentOrdersResponse.data)
        ? paymentOrdersResponse.data
        : []
      this.paymentOrdersSourceLoaded = true

      return this.paymentOrdersSource
    },
    async changeTab (tabId) {
      this.activeTab = tabId
      await this.ensureTabData(tabId)
    },
    async ensureTabData (tabId) {
      if (this.sectionLoaded[tabId]) {
        return
      }

      if (tabId === 'documents') {
        await this.loadDocuments()
        return
      }

      if (tabId === 'approvals') {
        await this.loadApprovals()
        return
      }

      if (tabId === 'billing') {
        await this.loadBilling()
      }
    },
    async loadSummary (force) {
      if (this.sectionLoaded.summary && !force) {
        return
      }

      this.loading.summary = true
      this.sessionStudent = this.resolveLoggedStudent()

      try {
        await this.ensureAccessState(force)
        if (!this.accessState.hasAccess) {
          this.summary = null
          this.sectionLoaded.summary = true
          this.feedback.message = ''
          return
        }

        const sourceResults = await Promise.allSettled([
          this.ensureDocumentsSource(force),
          this.ensureApprovalsSource(force),
          this.ensurePaymentOrdersSource(force),
        ])

        const hasPartialFailures = sourceResults.some(result => result.status === 'rejected')
        this.summary = await getGraduationProcessSummary(this.getSummaryContext())
        this.sectionLoaded.summary = true

        this.feedback = hasPartialFailures
          ? {
            tone: 'warning',
            message: 'No fue posible cargar la información completa del proceso. Se muestran los datos disponibles.',
          }
          : {
            tone: 'info',
            message: '',
          }
      } catch (error) {
        console.log(error)
        if (!this.accessState.loaded) {
          this.accessState = {
            loaded: true,
            hasAccess: false,
            reason: 'service_error',
            message: 'No fue posible validar el acceso al proceso de grados en este momento.',
          }
          this.summary = null
          this.sectionLoaded.summary = true
          this.feedback = {
            tone: 'warning',
            message: 'No fue posible validar la inscripción activa del proceso de grados.',
          }
          return
        }

        this.summary = await getGraduationProcessSummary(this.getSummaryContext())
        this.sectionLoaded.summary = true
        this.feedback = {
          tone: 'warning',
          message: 'No fue posible cargar la información completa del proceso. Se muestran los datos disponibles.',
        }
      } finally {
        this.loading.summary = false
      }
    },
    async loadDocuments (force) {
      if (this.sectionLoaded.documents && !force) {
        return
      }

      this.loading.documents = true
      try {
        await this.ensureAccessState(force)
        if (!this.accessState.hasAccess) {
          this.documents = []
          this.sectionLoaded.documents = true
          return
        }

        await this.ensureDocumentsSource(force)
        this.documents = await getGraduationDocuments(this.documentsSource)
        await this.syncSummaryState()
        this.sectionLoaded.documents = true
      } catch (error) {
        console.log(error)
        this.documents = []
        this.sectionLoaded.documents = true
        this.feedback = {
          tone: 'warning',
          message: 'No fue posible cargar la información documental del proceso.',
        }
      } finally {
        this.loading.documents = false
      }
    },
    async loadApprovals (force) {
      if (this.sectionLoaded.approvals && !force) {
        return
      }

      this.loading.approvals = true
      try {
        await this.ensureAccessState(force)
        if (!this.accessState.hasAccess) {
          this.approvals = []
          this.sectionLoaded.approvals = true
          return
        }

        await this.ensureApprovalsSource(force)
        this.approvals = await getGraduationApprovals(this.approvalsSource, this.getSummaryContext())
        await this.syncSummaryState()
        this.sectionLoaded.approvals = true
      } catch (error) {
        console.log(error)
        this.approvals = []
        this.sectionLoaded.approvals = true
        this.feedback = {
          tone: 'warning',
          message: 'No fue posible consultar los avales desde utilitary en este momento.',
        }
      } finally {
        this.loading.approvals = false
      }
    },
    async loadBilling (force) {
      if (this.sectionLoaded.billing && !force) {
        return
      }

      this.loading.billing = true
      try {
        await this.ensureAccessState(force)
        if (!this.accessState.hasAccess) {
          this.billing = null
          this.sectionLoaded.billing = true
          return
        }

        await this.ensureDocumentsSource(force)
        await this.ensureApprovalsSource(force)
        await this.ensurePaymentOrdersSource(force)
        this.billing = await getGraduationBilling({
          sessionUser: this.sessionStudent,
          availableInscriptions: this.availableInscriptions,
          inscriptionStudent: this.activeInscriptionStudent,
          inscriptionAccess: this.inscriptionAccess,
          activeGrade: this.activeGrade,
          documentsSource: this.documentsSource,
          approvals: this.approvalsSource,
          paymentOrders: this.paymentOrdersSource,
          programCatalog: this.$store.state.ProgramsList,
          programCodeCatalog: this.$store.state.ProgramCodeList,
        })
        await this.syncSummaryState()
        this.sectionLoaded.billing = true
      } catch (error) {
        console.log(error)
        this.billing = await getGraduationBilling({
          sessionUser: this.sessionStudent,
          availableInscriptions: this.availableInscriptions,
          inscriptionStudent: this.activeInscriptionStudent,
          inscriptionAccess: this.inscriptionAccess,
          activeGrade: this.activeGrade,
          documentsSource: this.documentsSource,
          approvals: [],
          paymentOrders: this.paymentOrdersSource,
          programCatalog: this.$store.state.ProgramsList,
          programCodeCatalog: this.$store.state.ProgramCodeList,
        })
        this.sectionLoaded.billing = true
        this.feedback = {
          tone: 'warning',
          message: 'No fue posible sincronizar toda la información de la orden de pago del proceso de grado.',
        }
      } finally {
        this.loading.billing = false
      }
    },
    async refreshAll () {
      this.accessState.loaded = false
      this.approvalsSourceLoaded = false
      this.documentsSourceLoaded = false
      this.paymentOrdersSourceLoaded = false
      this.availableInscriptions = []
      this.selectedInscriptionKey = ''
      this.activeInscriptionStudent = null
      this.inscriptionAccess = null
      this.activeGrade = null
      this.completionModalDismissed = false
      await Promise.all([
        this.loadSummary(true),
        this.loadDocuments(true),
        this.loadApprovals(true),
        this.loadBilling(true),
      ])

      if (this.accessState.hasAccess) {
        this.feedback = {
          tone: 'info',
          message: 'La información del proceso se actualizó correctamente.',
        }
      }
    },
  },
}
</script>

<style scoped>
.student-graduation {
  --ibero-primary: #a2273c;
  --ibero-primary-soft: rgba(162, 39, 60, 0.1);
  --ibero-accent: #f2a900;
  --ibero-text: #2f2f2f;
  --ibero-muted: #6b7280;
  --ibero-border: #e5e7eb;
  --ibero-bg: #f8f9fb;
  min-height: 100vh;
  padding: 20px 14px 36px;
  background: var(--ibero-bg);
}

.student-graduation__shell {
  max-width: 1260px;
  margin: 0 auto;
}

.student-graduation__completion-overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.46);
  backdrop-filter: blur(6px);
}

.student-graduation__completion-modal {
  position: relative;
  width: min(100%, 760px);
  border-radius: 28px;
  overflow: hidden;
  background:
    radial-gradient(circle at top right, rgba(242, 169, 0, 0.26), transparent 34%),
    radial-gradient(circle at left center, rgba(162, 39, 60, 0.14), transparent 30%),
    linear-gradient(145deg, #fffaf2 0%, #ffffff 42%, #fff7fb 100%);
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.24);
}

.student-graduation__completion-shell {
  position: relative;
  padding: 34px 32px 28px;
}

.student-graduation__completion-close {
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 1;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  color: var(--ibero-primary);
  cursor: pointer;
  font-size: 28px;
  line-height: 1;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
}

.student-graduation__completion-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(242, 169, 0, 0.14);
  color: #875d00;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.student-graduation__completion-markers {
  display: flex;
  gap: 10px;
  margin-top: 18px;
}

.student-graduation__completion-markers span {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--ibero-accent), #ffd56a);
  box-shadow: 0 8px 18px rgba(242, 169, 0, 0.24);
}

.student-graduation__completion-markers span:nth-child(2) {
  background: linear-gradient(135deg, #d24b64, var(--ibero-primary));
}

.student-graduation__completion-markers span:nth-child(3) {
  background: linear-gradient(135deg, #ffcf87, #f5a800);
}

.student-graduation__completion-modal h2 {
  max-width: 560px;
  margin: 20px 0 0;
  color: #2f2f2f;
  font-size: 36px;
  line-height: 1.08;
  font-weight: 800;
}

.student-graduation__completion-copy {
  max-width: 620px;
  margin-top: 18px;
  color: #4b5563;
  font-size: 16px;
  line-height: 1.7;
}

.student-graduation__completion-copy p {
  margin: 0;
}

.student-graduation__completion-copy p + p {
  margin-top: 12px;
}

.student-graduation__completion-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 22px;
}

.student-graduation__completion-highlights span {
  display: inline-flex;
  align-items: center;
  padding: 9px 12px;
  border: 1px solid rgba(162, 39, 60, 0.12);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  color: var(--ibero-text);
  font-size: 13px;
  font-weight: 700;
}

.student-graduation__completion-action {
  margin-top: 26px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--ibero-primary), #c63d57);
  color: #fff;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
  padding: 13px 18px;
  box-shadow: 0 14px 28px rgba(162, 39, 60, 0.24);
}

.student-graduation__completion-transition-enter-active,
.student-graduation__completion-transition-leave-active {
  transition: opacity 0.24s ease;
}

.student-graduation__completion-transition-enter-active .student-graduation__completion-modal,
.student-graduation__completion-transition-leave-active .student-graduation__completion-modal {
  transition: transform 0.24s ease, opacity 0.24s ease;
}

.student-graduation__completion-transition-enter,
.student-graduation__completion-transition-leave-to {
  opacity: 0;
}

.student-graduation__completion-transition-enter .student-graduation__completion-modal,
.student-graduation__completion-transition-leave-to .student-graduation__completion-modal {
  transform: translateY(18px) scale(0.98);
  opacity: 0;
}

.student-graduation__header-card,
.student-graduation__hero,
.student-graduation__tabs,
.student-graduation__panel,
.student-graduation__empty-state,
.student-graduation__feedback {
  background: #fff;
  border: 1px solid var(--ibero-border);
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.student-graduation__header-card {
  margin-bottom: 18px;
  padding: 18px 22px 22px;
}

.student-graduation__header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.student-graduation__logo {
  width: 190px;
  max-width: 100%;
  height: auto;
}

.student-graduation__title {
  margin-left: 0;
  margin-bottom: 12px;
  color: var(--ibero-primary);
  border-bottom-color: var(--ibero-primary);
}

.student-graduation__intro {
  margin: 0;
  color: var(--ibero-muted);
  font-size: 14px;
  line-height: 1.7;
}

.student-graduation__refresh {
  border: 1px solid var(--ibero-primary);
  border-radius: 8px;
  background: #fff;
  color: var(--ibero-primary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 16px;
  transition: background 0.2s ease, color 0.2s ease;
}

.student-graduation__refresh:hover {
  background: var(--ibero-primary);
  color: #fff;
}

.student-graduation__content {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.student-graduation__empty-state {
  padding: 28px 24px;
  text-align: center;
}

.student-graduation__empty-state h2 {
  margin: 0;
  color: var(--ibero-primary);
  font-size: 26px;
  font-weight: 700;
}

.student-graduation__empty-state p {
  max-width: 720px;
  margin: 14px auto 0;
  color: var(--ibero-muted);
  font-size: 15px;
  line-height: 1.7;
}

.student-graduation__hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 22px;
  padding: 22px;
}

.student-graduation__hero-main {
  min-width: 0;
}

.student-graduation__callout {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(242, 169, 0, 0.12);
  color: #875d00;
  font-size: 12px;
  font-weight: 700;
}

.student-graduation__hero h2 {
  margin: 16px 0 0;
  color: var(--ibero-text);
  font-size: 30px;
  font-weight: 700;
}

.student-graduation__hero-meta {
  margin: 10px 0 0;
  color: var(--ibero-muted);
  font-size: 15px;
}

.student-graduation__program-switcher {
  margin-top: 18px;
  padding: 16px;
  border: 1px solid rgba(162, 39, 60, 0.12);
  border-radius: 14px;
  background: linear-gradient(145deg, rgba(162, 39, 60, 0.05), rgba(242, 169, 0, 0.08));
}

.student-graduation__program-switcher-label {
  margin: 0;
  color: var(--ibero-text);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
}

.student-graduation__program-switcher-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}

.student-graduation__program-switcher-option {
  min-width: min(100%, 260px);
  border: 1px solid rgba(162, 39, 60, 0.12);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  color: var(--ibero-text);
  cursor: pointer;
  padding: 12px 14px;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.student-graduation__program-switcher-option strong,
.student-graduation__program-switcher-option span {
  display: block;
}

.student-graduation__program-switcher-option strong {
  font-size: 14px;
  line-height: 1.5;
}

.student-graduation__program-switcher-option span {
  margin-top: 6px;
  color: var(--ibero-muted);
  font-size: 12px;
}

.student-graduation__program-switcher-option:hover,
.student-graduation__program-switcher-option.is-active {
  border-color: rgba(162, 39, 60, 0.42);
  box-shadow: 0 12px 24px rgba(162, 39, 60, 0.1);
  transform: translateY(-1px);
}

.student-graduation__program-switcher-option.is-active {
  background: #fff;
}

.student-graduation__detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 20px;
}

.student-graduation__detail-grid article,
.student-graduation__next-step {
  border: 1px solid var(--ibero-border);
  border-left: 4px solid var(--ibero-primary);
  border-radius: 10px;
  background: #fff;
  padding: 14px 16px;
}

.student-graduation__detail-grid span,
.student-graduation__next-step span {
  display: block;
  color: var(--ibero-muted);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.student-graduation__detail-grid strong,
.student-graduation__next-step strong {
  display: block;
  margin-top: 8px;
  color: var(--ibero-text);
  font-size: 15px;
  line-height: 1.5;
}

.student-graduation__hero-side {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.student-graduation__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  padding: 9px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
}

.student-graduation__status.is-success {
  background: rgba(34, 139, 34, 0.12);
  color: #206a20;
}

.student-graduation__status.is-warning {
  background: rgba(242, 169, 0, 0.16);
  color: #8a6200;
}

.student-graduation__status.is-info {
  background: rgba(162, 39, 60, 0.12);
  color: var(--ibero-primary);
}

.student-graduation__hero-side p {
  margin: 0;
  color: var(--ibero-muted);
  font-size: 14px;
  line-height: 1.7;
}

.student-graduation__next-step p {
  margin: 10px 0 0;
}

.student-graduation__feedback {
  padding: 12px 16px;
  color: var(--ibero-primary);
  font-size: 14px;
  font-weight: 600;
}

.student-graduation__feedback.is-info {
  background: rgba(162, 39, 60, 0.06);
  border-color: rgba(162, 39, 60, 0.15);
}

.student-graduation__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
}

.student-graduation__tabs button {
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--ibero-muted);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 12px;
}

.student-graduation__tabs button.is-active {
  color: var(--ibero-primary);
  border-bottom-color: var(--ibero-primary);
}

.student-graduation__panel {
  padding: 20px;
}

.student-graduation__loading-panel,
.student-graduation__initial-loading {
  display: grid;
  place-items: center;
  min-height: 220px;
  color: var(--ibero-muted);
  font-size: 15px;
}

@media (max-width: 980px) {
  .student-graduation__detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .student-graduation {
    padding: 16px 10px 28px;
  }

  .student-graduation__completion-overlay {
    padding: 14px;
  }

  .student-graduation__completion-shell {
    padding: 28px 20px 22px;
  }

  .student-graduation__header-card,
  .student-graduation__panel,
  .student-graduation__hero {
    padding: 16px;
  }

  .student-graduation__header-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .student-graduation__hero h2 {
    font-size: 24px;
  }

  .student-graduation__completion-modal h2 {
    font-size: 28px;
  }

  .student-graduation__detail-grid {
    grid-template-columns: 1fr;
  }
}
</style>
